import React from 'react';

const LoadingSpinner = () => (
	<div className="spinner-container">
		<div className="lds-dual-ring" />
	</div>
);

export default LoadingSpinner;
